import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8eeb16ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "paging" }
const _hoisted_2 = {
  class: "paging-header subnavbar-header",
  "data-test": "sm-paging-header"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paging-item-wrapper" }, null, -1))
const _hoisted_4 = ["onClick", "onKeydown", "disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paging-item-wrapper" }, null, -1))

import { PageDetail } from "../../views/strengths-mapping/strengths-mapping.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'strengths-mapping-paging',
  props: {
    currentPageNumber: {},
    minPageNumber: {},
    maxPageNumber: {},
    maxAccessiblePageNumber: {},
    canGoToPreviousPage: { type: Boolean },
    canGoToNextPage: { type: Boolean },
    pageDetails: {}
  },
  emits: ["request-save-and-exit", "previous-page", "next-page", "go-to-page"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function saveAndExit(): void {
  emit("request-save-and-exit");
}

function previousPage(): void {
  emit("previous-page");
}

function nextPage(): void {
  emit("next-page");
}

function goToPage(pageNumber: number): void {
  emit("go-to-page", pageNumber);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, " Page " + _toDisplayString(_ctx.currentPageNumber) + " / " + _toDisplayString(_ctx.maxPageNumber), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["paging-body", [
        'page-number-' +
          (_ctx.currentPageNumber - _ctx.minPageNumber + 1) +
          '-of-' +
          (_ctx.maxAccessiblePageNumber - _ctx.minPageNumber + 1),
      ]])
    }, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageDetails, (page) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "paging-item-wrapper",
          key: page.pageNumber
        }, [
          (_openBlock(), _createElementBlock("a", {
            class: _normalizeClass(["page-number", { current: page.isCurrent }]),
            onClick: ($event: any) => (goToPage(page.pageNumber)),
            onKeydown: _withKeys(($event: any) => (goToPage(page.pageNumber)), ["enter"]),
            key: page.pageNumber,
            disabled: !page.isAvailable
          }, _toDisplayString(page.pageNumber), 43, _hoisted_4))
        ]))
      }), 128)),
      _hoisted_5
    ], 2)
  ]))
}
}

})